import { useState } from "react";
import { useGet } from "@/lib/api";
import { useSeo } from "@/lib/store";
import { ReelCard } from "@/components/ReelCard";

export const REEL_CATS = ["Hoodie Collection", "T-Shirt Collection", "Anime Designs", "Printing Process", "Behind the Scenes", "Streetwear Styling", "Customer Reviews"];

export default function Reels() {
  useSeo("The Den Experience — Reels", "Watch DEN & THREADS drops, printing process, styling and behind-the-scenes reels.");
  const { data = [] } = useGet("/reels");
  const [cat, setCat] = useState("");
  const list = cat ? data.filter((r) => r.category === cat) : data;
  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-14" data-testid="reels-page">
      <p className="eyebrow">Reels & video gallery</p>
      <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl leading-[0.86] mt-4">THE DEN EXPERIENCE —<br /><span className="text-neon">WATCH THE DROP</span></h1>
      <div className="flex gap-2 overflow-x-auto no-scrollbar mt-10 pb-2">
        {["", ...REEL_CATS].map((c) => <button key={c || "all"} onClick={() => setCat(c)} data-testid={`reel-filter-${c ? c.toLowerCase().replace(/\s/g, "-") : "all"}`} className={`chip shrink-0 ${cat === c ? "on" : ""}`}>{c || "All"}</button>)}
      </div>
      {list.length ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mt-10" data-testid="reels-grid">{list.map((r) => <ReelCard key={r.id} r={r} />)}</div>
      ) : <p className="py-24 text-center text-grey" data-testid="reels-empty">No reels in this category yet.</p>}
    </div>
  );
}
